export enum B2C_SSO_POLICY {
  SIGN_IN = 'B2C_1A_SIGNUP_SIGNIN',
  //eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  SIGN_UP = 'B2C_1A_SIGNUP_SIGNIN',
  IMPERSONATION = 'B2C_1A_IMPERSONATION'
}